import React, { useEffect, Fragment, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import ScriptLoader from '../../../page/components/script-loader';
import { openInsideChatTab } from '../../../page/components/inside-chat';
import { Helpers } from '../../../core/src/helpers';
import { withError } from '../../../shared/components/error-boundary';
import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';
import { formatMetricValue } from '../../../metrics/metrics-helpers';
import useTrackCustomMetric from '../../../hooks/useTrackCustomMetric';
import useUserData from '../../../hooks/useUserData';
import { useThirdPartyTags } from '../../../hooks/useSiteConfig';

import './chatbot.less';

const { setCookie, getCookie } = Helpers;

const DEFAULT_CHAT_HTML = `
<div id="webchat" role="main"></div>
       <span class="chatButtonGroup">
		  <span class="action_btn">
			<span class="buttonBorderStyle"><a href="/us-en/shop/cv/hp-store-contacts?jumpid=in_rose-chatbot" target="_blank" class="button2">LIVE AGENT</a></span>
			<span id="chatMenu" class="buttonBorderStyle"><a href="#MainMenu" class="button2">MAIN MENU</a></span>
			<span id="chatEnd" class="buttonBorderStyle"><a href="#EndChat" class="button2">END CHAT</a></span>
		  </span>
       </span>`;

var _isSmallMob = function () {
    var isMobileDevice = window.matchMedia('only screen and (max-width: 375px)');
    return isMobileDevice.matches;
};

var _isMediumMob = function () {
    var isMobileDevice = window.matchMedia('only screen and (max-width: 760px)');
    return isMobileDevice.matches;
};

const setStyles = () => {
    if (_isSmallMob() || _isMediumMob()) {
        const chatbox = document.getElementById('chatbox');
        if (chatbox.classList.contains('chatbox')) {
            if (window.matchMedia('(orientation: portrait)').matches) {
                // you're in PORTRAIT mode
                chatbox.style.height = '90%';
                chatbox.style.margin = '0 2px 35px 0 !important';
            }

            if (window.matchMedia('(orientation: landscape)').matches) {
                // you're in LANDSCAPE mode
                chatbox.style.height = '90%';
                chatbox.style.margin = '0 2px 35px 0 !important';
            }
        }
    }
};

const initializeBot = () => {
    window.minimize = function () {
        document.getElementById('chatbox').style.display = 'none';
        document.getElementById('chatboxMin').style.display = 'block';
    };

    window.maximize = function () {
        document.getElementById('chatbox').style.display = 'flex';
        document.getElementById('chatboxMin').style.display = 'none';
    };

    var botTokenRetryCount = 0;
    const botApiService = 'https://directline.botframework.com';
    const styleOptions = {
        backgroundColor: 'White',
        botAvatarInitials: 'HP',
        botAvatarImage: 'https://www.hp.com/wcsstore/HPStorefrontAssetStore/images/Rose_50x50.jpg',
        bubbleBackground: 'white',
        bubbleFromUserBackground: '#D6EAF8',
        botAvatarBackgroundColor: '#A9A9A9',
        rootHeight: '92%',
        rootWidth: '100%',
        hideUploadButton: true,
        sendBoxTextWrap: true,
    };

    function create_UUID() {
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
        return 'dl_' + uuid;
    }

    console.log('Chat bot warming up..');
    let botUserID = create_UUID();
    console.log('dl_userID is', botUserID, { path: '/' });
    if (!getCookie('dl_userID')) {
        setCookie('dl_userID', botUserID);
        getToken();
    } else {
        botUserID = getCookie('dl_userID');
        setCookie('dl_userID', botUserID);
        if (getCookie('dl_Token') != null && getCookie('dl_ConvID') != null) {
            console.log('ConvID***', getCookie('dl_ConvID'));
            renderAzureChat(getCookie('dl_Token'));
        } else {
            // IF userid is available but token and conversation id unavailable
            getToken();
        }
    }
    console.log('dl_userID---', getCookie('dl_userID'));

    function getToken() {
        console.log('Fetching bot token from server');
        let botUserID = getCookie('dl_userID');
        if (botUserID == null || botUserID == '') {
            botUserID = create_UUID();
            console.log('botUserID is null so create a new user id ' + botUserID);
            setCookie('dl_userID', botUserID);
        }

        axios
            .get(`https://${window.location.hostname}/us-en/shop/generateBotTokenCmd?storeId=10151&userId=${botUserID}`)
            .then(({ data }) => {
                console.log('data in getToken', data);
                if (null != data) {
                    data = data.replace('/*', '').replace('*/', '').trim();
                    var response = JSON.parse(data);
                    if (response.token != null && response.token !== undefined && response.token != '') {
                        response = response.token;
                        if (
                            response.token != null &&
                            response.conversationId != null &&
                            response.token != '' &&
                            response.conversationId != ''
                        ) {
                            setCookie('dl_ConvID', response.conversationId);
                            setCookie('dl_Token', response.token);
                            renderAzureChat(getCookie('dl_Token'));
                        } else {
                            console.log('Empty response for conversationId/token');
                        }
                    } else {
                        console.log('Empty token response');
                    }
                }
            })
            .catch(e => {
                console.log('unable to fetch bot token from server');
                console.log(e);
            });
    }

    function createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }

    function renderAzureChat(tokenVal) {
        console.log('user id in render Azure chat is ' + getCookie('dl_userID'));
        if (window.WebChat) {
            const botConnection = window.WebChat.createDirectLine({ token: tokenVal });
            botConnection.connectionStatus$.subscribe(function (status) {
                console.log('---- > Current Bot Connection status is ' + status);
                handleConnection(status);
            });

            function TriggerEvent(eventName) {
                botConnection
                    .postActivity({
                        type: 'event',
                        from: { id: getCookie('dl_userID') },
                        name: eventName,
                        value: eventName,
                    })
                    .subscribe(function (id) {
                        console.log('event ' + eventName + ' sent');
                    });
            }

            window.chatBotTriggerEvent = TriggerEvent;
            document.getElementById('chatEnd').addEventListener('click', window.minimize);
            document.getElementById('chatMenu').addEventListener('click', () => TriggerEvent('Menu'));

            window.WebChat.renderWebChat(
                {
                    directLine: botConnection,
                    bot: { id: 'hpusstoredevbot' },
                    userID: getCookie('dl_userID'),
                    user: { id: getCookie('dl_userID') },
                    styleOptions: styleOptions,
                },
                document.getElementById('webchat')
            );
            document.querySelector('#webchat > *').focus();
            let newContent =
                '<div class="chatbox-top"><div class="chatbox-avatar"><img src="https://www.hp.com/wcsstore/HPStorefrontAssetStore/images/Rose_80X80.jpg" style="border-radius: 50%;"  /></div>' +
                '<div class="chat-partner-name"><span class="chatBotstatus online"></span><span id="chatPartner">Ask Rose. I\'m your HP Store Virtual Assistant</span></div>' +
                '<div class="chatIcons"><a href="#ChatWithRose" onclick="window.minimize()"><img id="roseCloseIcon" class="closeIcon" src="https://www.hp.com/wcsstore/HPStorefrontAssetStore/img/myaccount/minus.png" /></a></div></div>';
            const newHeader = createElementFromHTML(newContent);
            if (!document.querySelector('#webchat div').classList.contains('chatbox-top')) {
                document.getElementById('webchat').insertBefore(newHeader, document.querySelector('#webchat > div'));
            }
        }
    }

    function handleConnection(connectionStatus) {
        switch (connectionStatus) {
            case 0:
                console.log('Uninitialized');
                break;
            case 1:
                console.log('Connecting');
                break;
            case 2:
                console.log('Online');
                botTokenRetryCount = 0;
                break;
            case 3:
                console.log('ExpiredToken');
                refreshToken();
                break;
            case 4:
                console.log('FailedToConnect');
                if (botTokenRetryCount <= 5) {
                    console.log('Retry bot connection ' + botTokenRetryCount);
                    let botUserID = create_UUID();
                    setCookie('dl_userID', botUserID);
                    getToken();
                    botTokenRetryCount++;
                }
                break;
            case 5:
                console.log('Ended');
                break;
        }
    }

    // Refresh token every 30mins to avoid expiry
    setInterval(function () {
        refreshToken();
    }, 1800000);

    function refreshToken() {
        console.log('Refreshing the token...');
        let botUserID = getCookie('dl_userID');
        axios
            .post(
                `${botApiService}/v3/directline/tokens/refresh?conversationId=${getCookie('dl_ConvID')}`,
                {},
                { headers: { Authorization: 'Bearer ' + getCookie('dl_Token') } }
            )
            .then(data => {
                console.log('token refreshed');
                if (null != data) {
                    console.log(data);
                }
            })
            .catch(e => {
                console.log('unable to refresh token');
                if (botTokenRetryCount <= 5) {
                    console.log('retry for new connection ' + botTokenRetryCount);
                    let botUserID = create_UUID();
                    setCookie('dl_userID', botUserID);
                    getToken();
                    botTokenRetryCount++;
                }
                console.log(e);
            });
    }

    window.onload = function setChatboatHeight() {
        setStyles();
    };

    window.addEventListener('orientationchange', setStyles);
    document.getElementById('chatboxMin').style.display = 'block';
};

export const Chatbot = ({ chatMenuHtml = DEFAULT_CHAT_HTML }) => {
    const [chatReady, setChatReady] = useState(false);
    const { enableInsideChat, enableRose } = useThirdPartyTags(['enableInsideChat', 'enableRose']);
    let chatInterval;
    useEffect(() => {
        if (typeof window !== 'undefined' && chatReady && !enableInsideChat) {
            initializeBot();
        }
        return () => {
            try{
                window.removeEventListener('orientationchange', setStyles);
                clearInterval(chatInterval);
            }catch(e){}
        };
    }, [chatReady, enableInsideChat]);
    const onScriptCreate = useCallback(() => {
        chatInterval = setInterval(() => {
            try {
                if (window.WebChat) {
                    setChatReady(true);
                    clearInterval(chatInterval);
                    window.initializeBot = initializeBot;
                }
            } catch (e) {}
        }, 500);
        setTimeout(() => {
            try {
                //clear interval after waiting 30 seconds
                clearInterval(chatInterval);
            } catch (e) {}
        }, 30000);
    });
    const { userData } = useUserData();
    const { profileData, updatedFromService } = userData || {};
    const { isccf } = profileData || {};
    const onChatClick = useCallback(() => {
        try {
            if(enableInsideChat){
                return openInsideChatTab();
            }
            window.maximize();
            trackCustomMetric('chat', {
                event: 'e_chat',
                chatAction: `rose_start`,
            });
        } catch (e) {}
    }, [enableInsideChat]);

    const trackCustomMetric = useTrackCustomMetric();

    const chatBotRef = useRef();

    useEffect(() => {
        let trackRoseButtonClicks;
        if(!enableInsideChat){
            trackRoseButtonClicks = e => {
                try {
                    let { target } = e;
                    if (target.id === 'roseCloseIcon') {
                        return trackCustomMetric('chat', {
                            event: 'e_chat',
                            chatAction: 'rose_end',
                        });
                    }
    
                    let textContent = target.textContent.toLowerCase().trim();
                    if (
                        ['live agent', 'main menu', 'end chat'].includes(textContent) ||
                        target.closest('.ac-actionSet button[role="button"][type="button"]')
                    ) {
                        return trackCustomMetric('chat', {
                            event: 'e_chat',
                            chatAction: `rose_menu_${formatMetricValue(textContent)}`,
                        });
                    }
    
                    if (target.closest('button.webchat__icon-button[title="Send"]')) {
                        trackCustomMetric('chat', {
                            event: 'e_chat',
                            chatAction: `rose_typed_message`,
                        });
                    }
                } catch (e) {}
            };
    
            // onClickCapture in React < 17 still gets triggered after vanilla js capturing phase event handlers. The chatbot code stops propagation so onClickCapture won't trigger.
            Helpers.attemptFunc(() => chatBotRef.current.addEventListener('click', trackRoseButtonClicks, true));
        }
        
        return () => {
            // onClickCapture in React < 17 still gets triggered after vanilla js capturing phase event handlers. The chatbot code stops propagation so onClickCapture won't trigger.
            Helpers.attemptFunc(() => chatBotRef.current.removeEventListener('click', trackRoseButtonClicks, true));
        };
    }, [enableInsideChat]);

    const trackRoseEnterPress = useCallback(
        e => {
            try {
                if (
                    [e.which, e.keyCode].includes(13) &&
                    document.activeElement.getAttribute('data-id') === 'webchat-sendbox-input'
                ) {
                    trackCustomMetric('chat', {
                        event: 'e_chat',
                        chatAction: `rose_typed_message`,
                    });
                }
            } catch (e) {}
        },
        [trackCustomMetric]
    );

    //wait till user data is available and make sure it's not call center
    if (!updatedFromService || isccf) {
        return null;
    }

    if (typeof window === 'undefined') {
        return null;
    }

    let chatbotDivProps = {};
    let chatbotCommonProps = {};
    
    if(enableRose && !enableInsideChat) {
        chatbotDivProps = { 
            onKeyDown: trackRoseEnterPress, 
            dangerouslySetInnerHTML: Helpers.createMarkup(chatMenuHtml) 
        }
        chatbotCommonProps = { style: { display: 'none' } };
    }
    return (
        <Fragment>
            {
                !enableInsideChat && (
                    <ScriptLoader
                        onCreate={onScriptCreate}
                        name="chatbot"
                        url={'https://www.hp.com/wcsstore/HPStorefrontAssetStore/js/webchat.js'}
                    />
                )
            }
            {/*dangerously insert webchat html so it never re-renders*/}
            <div
                className="chatbox"
                id="chatbox"
                style={{ display: 'none' }}
                ref={chatBotRef}
                {...chatbotDivProps}
            />
            <div id="chatboxMin" {...chatbotCommonProps}>
                <div className="chatbox-avatar-min">
                    <a
                        href="#ChatWithRose"
                        onClick={onChatClick}
                        title="Ask Rose. I'm your HP Store Virtual Assistant(U.S. store only)."
                    >
                        <img
                            src="https://www.hp.com/wcsstore/HPStorefrontAssetStore/images/Rose_80X80.jpg"
                            style={{ borderRadius: '50%' }}
                            alt="Chat"
                        />
                    </a>
                </div>
            </div>
        </Fragment>
    );
};

export default withError(
    ({ lazyLoadSettings = { robots: false, skip: true, mobileOffset: 500, offset: 1000 }, ...restProps }) => {
        const { enableRose = true, enableInsideChat } = useThirdPartyTags(['enableRose', 'enableInsideChat']);
        if (!enableRose && !enableInsideChat) {
            return null;
        }
        return (
            <AboveTheFoldOnlyServerRender {...lazyLoadSettings}>
                <Chatbot {...restProps} />
            </AboveTheFoldOnlyServerRender>
        );
    }
);
